import Login from "views/Auth/Login.js";
import EsqueceuSenha from "views/Auth/EsqueceuSenha";
import Inicio from "views/Home/InicioAux.js";
import TrocarSenha from "views/Auth/TrocarSenha.js";
import ManutencaoDRE from "views/ManutencaoDRE/ManutencaoDRE";
import DREAdministrativo from "views/DREAdministrativo/DREAdministrativo";
import DREExcecoesLista from "views/DREExcecoes/DREExcecaoLista";
import UsuarioLista from "views/Seguranca/UsuarioLista";
import CentroCustos from "views/Cadastros/CentroCustos";
import IndicadorDRE from "views/IndicadorDRE/IndicadorDRE";
import IndicesExtras from "views/IndicesExtras/IndicesExtras";
import RelatoriosLista from "views/Relatorios/RelatoriosLista";
import DashboardConsolidadoBI from "views/Dashboard/DashboardConsolidado/DashboardConsolidadoBI";
import Dashboard13MBI from "views/Dashboard/Dashboard13M/Dashboard13MBI";
import ComissoesReembolsoDRE from "views/ComissoesReembolsoDRE/ComissoesReembolsoFicha";
import DREElegiveis from "views/DREElegiveis/DREElegiveisFicha"
import DRECadTim from "views/DRECadTim/DRECadTim";

var routes = [
  {
    path: "/login",
    name: "Login",
    icon: "fas fa-chart-line",
    component: Login,
    layout: "/auth",
    sidebar: false
  },
  {
    path: "/esqueceusenha",
    name: "Esqueceu Senha",
    icon: "",
    component: EsqueceuSenha,
    layout: "/auth",
    sidebar: false
  },
  {
    path: "/trocarsenha",
    name: "TrocarSenha",
    icon: "",
    component: TrocarSenha,
    layout: "/admin",
    sidebar: false
  },
  {
    path: "/inicio",
    name: "Inicio",
    icon: "fas fa-home",
    component: Inicio,
    layout: "/admin",
    sidebar: true
  },
  {
    codigoFuncionalidade: "Dashboard",
    name: "Dashboard",
    icon: "fas fa-chart-line",
    layout: "/admin",
    sidebar: true,
    submenus: [
      {
        codigoFuncionalidade: "Dashboard",
        path: "/DashboardConsolidado",
        name: "Consolidado",
        icon: "fas fa-chart-pie",
        component: DashboardConsolidadoBI,
        layout: "/admin",
        sidebar: true,
      },
      {
        codigoFuncionalidade: "Dashboard",
        path: "/DashboardEvolucaoMensal",
        name: "Evolução Mensal",
        icon: "fas fa-chart-bar",
        component: Dashboard13MBI,
        layout: "/admin",
        sidebar: true,
      }
    ]
  },
  {
    codigoFuncionalidade: "ManutencaoDRE",
    path: "/ManutencaoDRE",
    name: "Manutenção DRE",
    icon: "fas fa-edit",
    component: ManutencaoDRE,
    layout: "/admin",
    sidebar: true,
  },
  {
    codigoFuncionalidade: "DREAdministrativo",
    path: "/DREAdministrativo",
    name: "DRE Administrativo",
    icon: "fas fa-edit",
    component: DREAdministrativo,
    layout: "/admin",
    sidebar: true
  },
  {
    codigoFuncionalidade: "CentroCustos",
    path: "/centrocustos",
    name: "Centro de Custos",
    icon: "fas fa-list-ol",
    component: CentroCustos,
    layout: "/admin",
    sidebar: true
  },
  {
    codigoFuncionalidade: "DREExcecoes",
    path: "/DREExcecoes",
    name: "DRE Exceções",
    icon: "fas fa-times-circle",
    component: DREExcecoesLista,
    layout: "/admin",
    sidebar: true
  },
  {
    codigoFuncionalidade: "IndicesExtras",
    path: "/indicesextras",
    name: "Índices Extras",
    icon: "fas fa-percentage",
    component: IndicesExtras,
    layout: "/admin",
    sidebar: true
  },
  {
    codigoFuncionalidade: "IndicadorDRE",
    path: "/IndicadorDRE",
    name: "Indicador DRE",
    icon: "fas fa-file-download",
    component: IndicadorDRE,
    layout: "/admin",
    sidebar: true
  },
  {
    codigoFuncionalidade: "Relatorios",
    path: "/RelatoriosLista",
    name: "Relatórios",
    icon: "fas fa-file",
    component: RelatoriosLista,
    layout: "/admin",
    sidebar: true
  },
  {
    codigoFuncionalidade: "Usuarios",
    path: "/cadastrousuarios",
    name: "Usuários",
    icon: "fas fa-users",
    component: UsuarioLista,
    layout: "/admin",
    sidebar: true
  },
  {
    name: "Processamento DRE",
    icon: "fas fa-cloud-upload-alt",
    layout: "/admin",
    sidebar: true,
    submenus: [
      {
        codigoFuncionalidade: "DRECadTIM",
        path: "/DRECadTIM",
        name: "Atualização CadTIM",
        icon: "fas fa-database",
        component: DRECadTim,
        layout: "/admin",
        sidebar: true
      },
      {
        codigoFuncionalidade: "DREElegiveis",
        path: "/DREElegiveis",
        name: "DRE Elegíveis",
        icon: "fas fa-clipboard-list",
        component: DREElegiveis,
        layout: "/admin",
        sidebar: true
      },
      {
        codigoFuncionalidade: "ComissoesReembolsoDRE",
        path: "/ComissoesReembolsoFicha",
        name: "Comissões e Reembolso",
        icon: "fas fa-money-check-alt",
        component: ComissoesReembolsoDRE,
        layout: "/admin",
        sidebar: true
      },
    ]
  }
];
export default routes;
